var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilAdminSettingsMenuIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 10.8528C3.25 9.28728 4.09442 7.84348 5.4589 7.07597L10.8756 4.02915C12.1946 3.28716 13.8054 3.28716 15.1244 4.02915L20.5411 7.07599C21.9057 7.8435 22.75 9.2873 22.75 10.8528V16.8012C22.75 18.3669 21.9057 19.8106 20.5411 20.5782L15.1244 23.6249C13.8054 24.3669 12.1946 24.3669 10.8756 23.625L5.459 20.5785C4.09446 19.811 3.25 18.3671 3.25 16.8016V10.8528ZM9.20837 13.8273C9.20837 11.7332 10.9059 10.0356 13 10.0356C15.0941 10.0356 16.7917 11.7332 16.7917 13.8273C16.7917 15.9214 15.0941 17.6189 13 17.6189C10.9059 17.6189 9.20837 15.9214 9.20837 13.8273Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilAdminSettingsMenuIconActive);
export default __webpack_public_path__ + "static/media/util-admin-settings-menu-icon-active.07bbac3ecee4192f2d67906539f1955f.svg";
export { ForwardRef as ReactComponent };